// extracted by mini-css-extract-plugin
export default {"shippingTooltip":"AdditionalShipping_shippingTooltip__xwIMX","left":"AdditionalShipping_left__X3qM7","right":"AdditionalShipping_right__muMvF"};